<template>
    <el-row id="loading" v-loading.fullscreen.lock.body="loading" :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <collectionBar :tags="tags" :subTitle="subTitle" :btnSave="true" :btnBack="true" @btnBackClick="btnBackClick" @btnSaveClick="btnSaveClick"/>
        <el-form label-width="120px"  hide-required-asterisk>

            <el-table :header-cell-style="{ 'color': 'black', 'font-size': '15px' }" :data="taskSettingList" border
                style="width: 100%;margin-top: 20px" stripe>
                <el-table-column fixed type="index" width="55">
                </el-table-column>
                <el-table-column min-width="50" prop="type_text" label="亮灯形式">
                </el-table-column>
                <el-table-column min-width="80" prop="alert_text" label="提示">
                </el-table-column>
                <el-table-column min-width="200" prop="rule_text_show" label="规则定义">
                </el-table-column>
                <el-table-column min-width="50" label="是否启用">
                    <template slot-scope="scope">
                        {{ scope.row.status === 'ACTIVE'? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="50" >
                    <template slot-scope="scope">
                        <el-button style="color: #fff;background: #FE904C;border:none;border-radius: 10%"
                            size="small" @click="handleDetail(scope.row)">详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-row style="margin-top: 30px;">
                <el-col :span="4" style="line-height:30px;font-weight: bold">
                    指定期初 （N-1周）填写任务
                </el-col>
                <el-col :span="12" style="margin-top:3px">
                    <el-select v-model="collectProfile.task_id_week_n1" size="small" placeholder="请选择数据采集任务"
                        style="width: 100%;">
                        <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                            :value="item.task_id">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row style="margin-top: 10px;">
                <el-col :span="4" style="line-height:30px;font-weight: bold">
                    指定期初 （N-2周）填写任务
                </el-col>
                <el-col :span="12" style="margin-top:3px">
                    <el-select v-model="collectProfile.task_id_week_n2" size="small" placeholder="请选择数据采集任务"
                        style="width: 100%;">
                        <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                            :value="item.task_id">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row style="margin-top: 10px;">
                <el-col :span="4" style="line-height:30px;font-weight: bold">
                    指定期初 （N-3周）填写任务
                </el-col>
                <el-col :span="12" style="margin-top:3px">
                    <el-select v-model="collectProfile.task_id_week_n3" size="small" placeholder="请选择数据采集任务"
                        style="width: 100%;">
                        <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                            :value="item.task_id">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row style="margin-top: 10px;">
                <el-col :span="4" style="line-height:30px;font-weight: bold">
                    指定期初 （N-4周）填写任务
                </el-col>
                <el-col :span="12" style="margin-top:3px">
                    <el-select v-model="collectProfile.task_id_week_n4" size="small" placeholder="请选择数据采集任务"
                        style="width: 100%;">
                        <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                            :value="item.task_id">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
        </el-form>
        <el-dialog :visible.sync="updateSettingDialog" width="700px" :show-close="false"
            style="vertical-align: center;">
            <div style="">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">参数设置
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click.stop="btnSaveSettingClick">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click.stop="close">
                                取消
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div style="margin-top: 20px;">
                    <el-form :model="updateSettingItemForm" ref="ruleForm" label-width="200px" class="demo-ruleForm"
                        hide-required-asterisk>
                        <el-form-item label="亮灯形式" prop="type_text" >
                            <el-input v-model="updateSettingItemForm.type_text" placeholder="请输入内容"
                                style="width: 70%"></el-input>
                        </el-form-item>
                        <el-form-item label="提示" prop="alert_text" >
                            <el-input v-model="updateSettingItemForm.alert_text" placeholder="请输入内容"
                                style="width: 70%"></el-input>
                        </el-form-item>
                        <el-form-item label="规则定义" prop="rule_text_plus" >
                           <div v-html="updateSettingItemForm.rule_text_plus"></div>
                        </el-form-item>
                        <el-form-item label="有效" prop="alert_text" >
                            <el-switch
                                v-model="updateSettingItemForm.status"
                                active-value="ACTIVE"
                                inactive-value="INACTIVE"
                                active-color="#13ce66">
                                </el-switch>
                        </el-form-item>
                    </el-form>

                </div>
            </div>

        </el-dialog>
        
    </el-row>

</template>

<script>
import collectionBar from '../../../components/collectionBar'
import http from '../../../APIService/http'

import { Message } from "element-ui";
export default {
    name: "taskParamsSetting",
    data() {
        return {
            loadingText:"",
            loading: false,
            tags: ['数据采集任务', '参数设置'],
            subTitle: '',
            channelCheckList: [
                "INSTITUTION",
                "HCP",
                "RETAILSTORE",
                "DISTRIBUTOR",
                "CUSTOMTABLE"
            ],
            updateSettingDialog:false,
            updateSettingItemForm: {
                type_text:'',
                alert_text:'',
                rule_text:'',
                rule_text_plus:'',
            },
            collectProfile: {},
            taskSettingList:[],
            taskList: [],
        }
    },


    components: {
        collectionBar,
    },
    created() {
        if (this.$route.params.task_id) {
            this.collectProfile = JSON.stringify(this.$route.params)
            localStorage.setItem('collectProfile', this.collectProfile)
        } else {
            this.collectProfile = JSON.parse(localStorage.getItem('collectProfile'))
        }
        console.log("collectProfile:",this.collectProfile)
        this.subTitle = this.collectProfile.task_name
        this.getCollectTask()
        this.getCollectTaskSetingList()
    },
    methods: {
        btnBackClick() {
            this.$router.push({ name: 'CollectionHome' })
        },
        async getCollectTask() {
            this.loading = true
            try {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    reference_obj: this.channelCheckList,
                    task_name: "",
                    start_date: '',
                    end_date: '',
                    limit: 20,
                    offset: 0
                }
                await http.post('/wapi/Collect/getCollectTask', data).then(res => {

                    console.log(res)
                    this.loading = false
                    if (res.success) {
                        if (res.data.result) {
                            console.log(res.data.result)
                            this.taskList = res.data.result.filter(item => item.task_id !== this.collectProfile.task_id);
                        }
                    } else {
                        this.error(res.message)
                    }
                })
            } catch (e) {
                this.loading = false
            }
        },

        async getCollectTaskSetingList() {
            try {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    task_id: this.collectProfile.task_id,
                    limit: 200,
                    offset: 0
                }
                await http.post('/crm/web/collection/getTaskRulesSetting_Luoshi', data).then(res => {
                    console.log(res)
                    if (res.success) {
                        this.taskSettingList = res.data;
                        for (const item of this.taskSettingList) {
                            item.rule_text_show = item.rule_text.replace('{$1}', item.rule_value_1?item.rule_value_1:'__');
                            item.rule_text_show = item.rule_text_show.replace('{$2}', item.rule_value_2?item.rule_value_2:'__');
                            item.rule_text_show = item.rule_text_show.replace('{$3}', item.rule_value_3?item.rule_value_3:'__');
                            item.rule_text_show = item.rule_text_show.replace('{$4}', item.rule_value_4?item.rule_value_4:'__');
                            item.rule_text_show = item.rule_text_show.replace('{$5}', item.rule_value_5?item.rule_value_5:'__');
                            item.rule_text_show = item.rule_text_show.replace('{$6}', item.rule_value_6?item.rule_value_6:'__');
                        }
                    } else {
                        this.error(res.message)
                    }
                })
            } catch (e) {
            }
        },
        handleDetail(row){

            this.updateSettingItemForm.key_id = row.key_id;
            this.updateSettingItemForm.type_text = row.type_text;
            this.updateSettingItemForm.alert_text = row.alert_text;
            this.updateSettingItemForm.rule_text = row.rule_text;
            this.updateSettingItemForm.rule_value_1 = row.rule_value_1?row.rule_value_1:'';
            this.updateSettingItemForm.rule_value_2 = row.rule_value_2?row.rule_value_2:'';
            this.updateSettingItemForm.rule_value_3 = row.rule_value_3?row.rule_value_3:'';
            this.updateSettingItemForm.rule_value_4 = row.rule_value_4?row.rule_value_4:'';
            this.updateSettingItemForm.rule_value_5 = row.rule_value_5?row.rule_value_5:'';
            this.updateSettingItemForm.rule_value_6 = row.rule_value_6?row.rule_value_6:'';
            this.updateSettingItemForm.status = row.status;

            this.updateSettingItemForm.rule_text_plus = row.rule_text;
            this.updateSettingItemForm.rule_text_plus = this.updateSettingItemForm.rule_text_plus.replace('{$1}','<input size="mini" id="rule_value_1" value="'+this.updateSettingItemForm.rule_value_1+'" style="width: 30px;border: none;border-bottom: 1px solid #000;text-align: center;"></input>');
            this.updateSettingItemForm.rule_text_plus = this.updateSettingItemForm.rule_text_plus.replace('{$2}','<input size="mini" id="rule_value_2" value="'+this.updateSettingItemForm.rule_value_2+'" style="width: 30px;border: none;border-bottom: 1px solid #000;text-align: center;"></input>');
            this.updateSettingItemForm.rule_text_plus = this.updateSettingItemForm.rule_text_plus.replace('{$3}','<input size="mini" id="rule_value_3" value="'+this.updateSettingItemForm.rule_value_3+'" style="width: 30px;border: none;border-bottom: 1px solid #000;text-align: center;"></input>');
            this.updateSettingItemForm.rule_text_plus = this.updateSettingItemForm.rule_text_plus.replace('{$4}','<input size="mini" id="rule_value_4" value="'+this.updateSettingItemForm.rule_value_4+'" style="width: 30px;border: none;border-bottom: 1px solid #000;text-align: center;"></input>');
            this.updateSettingItemForm.rule_text_plus = this.updateSettingItemForm.rule_text_plus.replace('{$5}','<input size="mini" id="rule_value_5" value="'+this.updateSettingItemForm.rule_value_5+'" style="width: 30px;border: none;border-bottom: 1px solid #000;text-align: center;"></input>');
            this.updateSettingItemForm.rule_text_plus = this.updateSettingItemForm.rule_text_plus.replace('{$6}','<input size="mini" id="rule_value_6" value="'+this.updateSettingItemForm.rule_value_6+'" style="width: 30px;border: none;border-bottom: 1px solid #000;text-align: center;"></input>');

            this.updateSettingDialog = true;
        },

        close() {
            this.$refs.ruleForm.resetFields();
            this.updateSettingDialog = false
        },
        async btnSaveSettingClick() {
            this.updateSettingItemForm.rule_value_1 = document.getElementById('rule_value_1')?document.getElementById('rule_value_1').value:'';
            this.updateSettingItemForm.rule_value_2 = document.getElementById('rule_value_2')?document.getElementById('rule_value_2').value:'';
            this.updateSettingItemForm.rule_value_3 = document.getElementById('rule_value_3')?document.getElementById('rule_value_3').value:'';
            this.updateSettingItemForm.rule_value_4 = document.getElementById('rule_value_4')?document.getElementById('rule_value_4').value:'';
            this.updateSettingItemForm.rule_value_5 = document.getElementById('rule_value_5')?document.getElementById('rule_value_5').value:'';
            this.updateSettingItemForm.rule_value_6 = document.getElementById('rule_value_6')?document.getElementById('rule_value_6').value:'';
            
           console.log(this.updateSettingItemForm)
           try {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    task_id: this.collectProfile.task_id,
                }
                data = {...data,...this.updateSettingItemForm}
                console.log(data)
                await http.post('/crm/web/collection/saveTaskRulesSettingItem_Luoshi', data).then(res => {
                    console.log(res)
                    if (res.data.success) {
                        this.updateSettingDialog = false;
                        Message({
                            type: 'success',
                            message: res.data.msg
                        })
                        this.getCollectTaskSetingList()
                    } else {
                        this.error(res.data.msg)
                    }
                })
            } catch (e) {
                this.error(e.message)
            }
        },
        async btnSaveClick() {

            try {
                await http.post('/crm/web/collection/saveTaskRulesSetting_Luoshi', this.collectProfile).then(res => {
                    console.log(res)
                    if (res.data.success) {

                        localStorage.removeItem('collectProfile')

                        let collectProfile = JSON.stringify(this.collectProfile)
                        localStorage.setItem('collectProfile', collectProfile)

                        Message({
                            type: 'success',
                            message: res.data.msg
                        })
                    } else {
                        this.error(res.data.msg)
                    }
                })
            } catch (e) {
                this.error(e.message)
            }

        },

    },

}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/collection/components/taskParamsSetting.vue